<template>
  <div class="overlay">
    <div class="onboarding-group-modal">
      <img src="@/assets/images/onboarding_group_modal.png" class="background-img" alt="background-img" />
      <div class="modal-content">
        <div class="modal-title">
          Great job, we’re almost done!
        </div>
        <div class="modal-title">
          Let’s route your calls and messages.
        </div>
        <custom-button custom-style="margin-top: 55px; width: 550px;" :on-click="onNext">
          Next >
        </custom-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from '@/components/CustomButton';

export default {
  name: 'OnboardingGroupModal',
  components: { CustomButton },
  props: {
    onNext: Function
  }
};
</script>

<style scoped lang="scss">
.onboarding-group-modal {
  position: relative;
  width: 850px;
  height: 450px;
  background-color: #ffffff;
  border-radius: 10px;

  .background-img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
  }

  .modal-content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 165px;
  }

  .modal-title {
    font-weight: 800;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    letter-spacing: -0.5px;
    color: $colorTitle;
  }
}
</style>
